import { CANCEL_PAYMENT_LINK } from "resources/actionTypes";

const initialState = {
  loading: false,
  error: null,
};

export function cancelPaymentLinkReducer(state = initialState, action) {
  switch (action.type) {
    case CANCEL_PAYMENT_LINK.CANCEL_PAYMENT_LINK_REQUESTED:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CANCEL_PAYMENT_LINK.CANCEL_PAYMENT_LINK_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case CANCEL_PAYMENT_LINK.CANCEL_PAYMENT_LINK_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
}
